import { request } from "../../../Services/Api"

// Read for two fields only — `is_business_health_available` and `warning_notification` — which say
// whether Health has a processor to read at all. The card numbers come from the KPI endpoint.
export const getHomeMainInfo = (params) =>
  request.api.get("/business-health/dashboard/main-info/", params)

export const getHomeKpiCards = (params) => request.api.get("/home/dashboard/kpi/", params)

export const getHomeRateChart = (params) =>
  request.api.get("/business-health/dashboard/overview/", params)

// // Home's own copy of Health's chargeback-rate chart. Same calculation on the backend, but reached
// // through /home so every user-panel role can see it — CHA1-3141 asks for three charts for everyone,
// // while /business-health/** stays Owner/Administrator only.
// export const getHomeRateChart = (params) => request.api.get("/home/dashboard/rate-chart/", params)

export const getHomePreventedChart = (params) =>
  request.api.get("/dashboard/charts/prevented/", params)

export const getHomeDeflectedChart = (params) =>
  request.api.get("/consumer-clarity/dashboard/chart/", params)

export const getHomeActionAlerts = (params) =>
  request.api.get("/restful_api/alerts/list/filter", params)
